import React, { useEffect } from 'react';
import { QuoteModalProvider } from '../context/QuoteModalContext';
import CloneNavbar from '../components/clone/Navbar';
import CloneFooter from '../components/clone/Footer';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Products from '../components/Products';
import ImageSection from '../components/ImageSection';
import WhyUs from '../components/WhyUs';
import Brands from '../components/Brands';
import FAQ from '../components/FAQ';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';
import FloatingPhoneCTA from '../components/FloatingPhoneCTA';

const HomeClonePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <QuoteModalProvider>
      <div className="App home-clone-page">
        <CloneNavbar />
        <Hero />
        <Features />
        <Products />
        <ImageSection />
        <WhyUs />
        <Brands />
        <FAQ />
        <Testimonials />
        <CTA />
        <CloneFooter />
        <FloatingPhoneCTA />
      </div>
    </QuoteModalProvider>
  );
};

export default HomeClonePage;
